import React from "react";
import "../../scss/dashboard/dashInicio.css";
import Imagen2 from "../../images/dashboardAbogados/Imagen2.svg";
import Imagen1 from "../../images/dashboardAbogados/Imagen1.svg";
import Plantilla from "../../images/dashboardAbogados/Plantillas.svg";
import Inicioslider from "./Inicioslider";
import { ProgressBar } from "react-step-progress-bar";
import AltInicioSlider from "./AltInicioSlider";
function DashInicioAlt() {
  return (
    <section className="dashInicio">
      <div className="saldo__texto">
        <h3>Total Saldo</h3>
      </div>
      <div className="saldo__texto">
        <h3>Plantillas más vendidas</h3>
      </div>
      <div className="saldo">
        <div className="inicio__box alt_inicio_box">
          <div className="alt_inicio_box-h6">
            <h6>Ingresos Finales</h6>
          </div>

          <div className="alt_inicio_box-income">
            <p className="alt_inicio_box-income-1">$2,286.56</p>
            <p className="alt_inicio_box-income-2">
              Actualizado hace 2 minutos
            </p>
          </div>
          <div className="alt_inicio_box-report">
            <p>Descargar Reporte</p>
          </div>
        </div>
      </div>
      <div className="plantillasVendidasDiv">
        <div className="inicio__box alt-inicio__box--mostSells">
          <div></div>
          <div className="alt-inicio__box--mostSells--name">
            <h4>Teletrabajo</h4>
          </div>
          <div className="alt-inicio__box--mostSells--income">
            <p className="mostSells--income-p">
              <span className="mostSells--income-span1">Ingresos</span> <br />
              <span className="mostSells--income-span2">$0</span>
            </p>
            <p className="mostSells--income-p2">3 ventas</p>
          </div>
          <div>
            <ProgressBar
              percent={50}
              filledBackground="#f37b33"
              unfilledBackground="#eaeaea"
              width={"100%"}
            />
          </div>
        </div>
        <div className="inicio__box alt-inicio__box--mostSells">
          <div></div>
          <div className="alt-inicio__box--mostSells--name">
            <h4>Arrendamiento</h4>
          </div>
          <div className="alt-inicio__box--mostSells--income">
            <p className="mostSells--income-p">
              <span className="mostSells--income-span1">Ingresos</span> <br />
              <span className="mostSells--income-span2">$0</span>
            </p>
            <p className="mostSells--income-p2">6 ventas</p>
          </div>
          <div>
            <ProgressBar
              percent={70}
              filledBackground="#f37b33"
              unfilledBackground="#eaeaea"
              width={"100%"}
            />
          </div>
        </div>
      </div>
      <div className="normal">
        <div className="inicio__box-slider altInicio-slider">
          <div className="altInicio-slider__h4">
            <h4>Movimiento Mensual</h4>
          </div>
          <div>
            <AltInicioSlider />
          </div>
        </div>
      </div>

      <div className="grande dashboardabogados-table">
        <div className="inicio__box1 saldo__texto">
          <h3>Estatus de plantillas</h3>
          <div>
            <table className="table">
              <tr>
                <th>ID</th>
                <th>NOMBRE DE PLANTILLA</th>
                <th>ESTATUS</th>
                <th>PRECIO</th>
                <th>VENTAS</th>
                <th>FECHA DE CREACIÓN</th>
              </tr>
              <tr>
                <td className="table__id">123</td>
                <td className="table__name">CARTA RENUNCIA VOLUNTARIA</td>
                <td>
                  <div className="table__status table__status--progress">
                    <p>Pendiente de Aprobación</p>
                  </div>
                </td>
                <td>
                  <div className="table__price">
                    <p>$300</p>
                  </div>
                </td>
                <td className="table__sells">0</td>
                <td className="table__date">12/16/21</td>
              </tr>
            </table>
          </div>
        </div>
      </div>
    </section>
  );
}

export default DashInicioAlt;
